<!-- Copyright 2020 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. -->

import {Layout} from '@react-spectrum/docs';
export default Layout;

import docs from 'docs:@react-stately/list';
import {HeaderInfo, TypeContext, InterfaceType, FunctionAPI, TypeLink} from '@react-spectrum/docs';
import packageData from '@react-stately/list/package.json';

---
category: Collections
keywords: [lists, state]
---

# useSingleSelectListState

<p>{docs.exports.useSingleSelectListState.description}</p>

<HeaderInfo
  packageData={packageData}
  componentNames={['useSingleSelectListState']} />

## API

<FunctionAPI function={docs.exports.useSingleSelectListState} links={docs.links} />

## Interface

<TypeContext.Provider value={docs.links}>
  <InterfaceType properties={docs.links[docs.exports.useSingleSelectListState.return.base.id].properties} />
</TypeContext.Provider>
